import {
  exportToExcel,
  convertToCSV,
  removeOmittedColumns,
  convertFieldObjectToValue,
  exportToHtml,
  exportToHtmlDynamicTable,
} from 'helpers/exporFileUtilities';
import { saveAs } from 'file-saver';

const prepareTableForExport = (table: any, customWidgetConfig: any) => {
  const clonedTable = JSON.parse(JSON.stringify(table));
  let filteredTable = removeOmittedColumns(clonedTable);
  filteredTable = convertFieldObjectToValue(filteredTable, customWidgetConfig);
  return filteredTable;
};

export const generateExcelFile = async (
  table: any,
  displayName: string,
  showTotals: any,
  customWidgetConfig: any
) => {
  try {
    const filteredTable = prepareTableForExport(table, customWidgetConfig);
    await exportToExcel(filteredTable, displayName || '', showTotals, customWidgetConfig);
  } catch (error) {
    console.error('Failed to generate Excel file', error);
  }
};

export const exportToCSV = (
  table: any,
  displayName: string,
  showTotals: any,
  customWidgetConfig: any
) => {
  try {
    const filteredTable = prepareTableForExport(table, customWidgetConfig);
    const csvData = convertToCSV(filteredTable, displayName || '', showTotals, customWidgetConfig);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, `${displayName || 'data'}.csv`);
  } catch (error) {
    console.error('Failed to generate CSV file', error);
  }
};

export const exportHtmlFile = (table: any, displayName: string, customWidgetConfig: any) => {
  try {
    const clonedTable = JSON.parse(JSON.stringify(table));
    const filteredTable = removeOmittedColumns(clonedTable);
    exportToHtml(filteredTable, displayName || '');
  } catch (error) {
    console.error('Failed to generate HTML file', error);
  }
};

export const exportHtmlFileDynamicTable = (
  table: any,
  displayName: string,
  customWidgetConfig: any
) => {
  try {
    const clonedTable = JSON.parse(JSON.stringify(table));
    const filteredTable = removeOmittedColumns(clonedTable);
    const normalizedTable = convertFieldObjectToValue(filteredTable, customWidgetConfig);
    exportToHtmlDynamicTable(normalizedTable, displayName || '');
  } catch (error) {
    console.error('Failed to generate HTML file', error);
  }
};
